import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from 'app/base';
import { Sistema } from 'app/entity/sistema.model';
import { Tabela } from 'app/entity/tabela.model';

@Component({
  selector: 'trilha-auditoria-etapa1',
  templateUrl: './trilha-auditoria-etapa1.component.html',
})
export class CrudTrilhaAuditoriaEtapa1Component extends BaseStepComponent {
  @Input() SistemaOptions: SelectItem[];
  @Input() PerfilOptions: SelectItem[];
  @Input() FuncionalidadeOptions: SelectItem[];
  @Input() controllerName: string;

  @Input() listaSistema: Sistema[];
  @Input() listaStatus: SelectItem[];
  dadosHistorico: any;
  tabelas: Tabela[];
  tabelasSelecionadas: any[];

  filtro = this.formBuilder.group({
    possui: [null],
    id_sistema: [null],
    id_perfil: [null],
    tipo: [null]
  });

  init() {
    this.filtro.get('id_sistema').valueChanges.subscribe(x => {
      this.service.Obter(`${this.controllerName}/tabelasSistemas`, x).subscribe(retorno => {
        this.tabelas = retorno;
      });
    });
    this.tabelasSelecionadas = [];
  }

  finalizar() {
    if (!this.tabelasSelecionadas.length) {
      this.showMsg('warn', 'Mensagem de Erro', `Insira uma tabela para realizar a auditoria.`)
    } else {
      this.confirmacao.confirm({
        header: 'Mensagem de Confirmação',
        message: `Confirma parâmetros para essa auditoria?`,
        accept: () => {
          this.observableUtilPanelDoc.setBlockedPanel(true);
          this.service.Adicionar(`${this.controllerName}/salvarTabelas`, this.tabelasSelecionadas).subscribe(
            sucess => {
              this.router.navigate(['../sistema/trilha-auditoria']);
              this.showMsg('success', 'Mensagem de Sucesso', 'Auditoria incluida com sucesso.')
              this.observableUtilPanelDoc.setBlockedPanel(false);
            },
            err => {
              this.showMsg('warn', 'Mensagem de Erro', `Erro ao incluir. ${err._body}`)
              this.observableUtilPanelDoc.setBlockedPanel(false)
            });
        }
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/trilha-auditoria/crud/etapas/trilha-auditoria-etapa1.component.ts